import React from 'react';
import { Header_2026, Footer_2026, LibroBlanco_2026 } from '../container';
import { useTranslation } from "react-i18next";

const LibroBl = () => {
  const [t, i18n] = useTranslation("librBlanc");

  return (
    <>
      <Header_2026 />
      <main _ngcontent-ng-c2339870667="" class="app-shell__page">
        <router-outlet _ngcontent-ng-c2339870667="">
        </router-outlet>
        <LibroBlanco_2026 />
      </main>
      <Footer_2026 />

    </>
  )
}

export default LibroBl
